var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"history-content"}},[_c('app-list',{attrs:{"listType":"history","records":_vm.data,"showHeaders":true,"displayColumns":_vm.displayColumns,"isListBusy":_vm.loading,"showSearch":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }